<template>
    <div id="ql-admin">
        <md-toolbar>
            <md-button class="md-icon-button" @click="toggleLeftSidenav">
                <md-icon>menu</md-icon>
            </md-button>
            <h2>Cuelist Admin Dashboard</h2>
        </md-toolbar>
        <core-nav-main :project="project" :user="user"></core-nav-main>
        <div class="user-list">
            <md-layout md-flex="25" md-flex-offset="5">
                <h2>List of User Stripe IDs</h2>
            </md-layout>
            <md-layout md-gutter="8" md-row class="header">
                <md-layout md-flex="30" md-flex-offset="5">
                    <span class="md-title">Name</span>
                </md-layout>
                <md-layout md-flex="15">
                    <span class="md-title">Active Pay</span>
                </md-layout>
                <md-layout md-flex="25">
                    <span class="md-title">Stripe ID</span>
                </md-layout>
            </md-layout>
            <br>
            <md-layout md-gutter="8" md-row v-for="usr in sortedUsers" :key="usr.uid">
                <md-layout md-column md-flex="30" md-flex-offset="5">
                    <strong>{{usr.username}}</strong>
                    <span>{{usr.email}}</span>
                </md-layout>
                <md-layout md-flex="15" md-align="center">
                    <md-checkbox v-model="usr.active_pay"></md-checkbox>
                </md-layout>
                <md-layout md-flex="25">
                    <md-input-container>
                        <md-input v-model="usr.stripe_id" />
                    </md-input-container>
                </md-layout>
                <md-button @click="updateUser(usr)">Update</md-button>
            </md-layout>
        </div>
        <core-footer></core-footer>
    </div>
</template>

<script>
// Vendor Libraries

import firebase from 'firebase';
import { mapGetters } from 'vuex';
import NavBus from '@/buses/nav';
// App Components
import CoreNavMain from '@/components/core/nav/main';
import CoreHeader from '@/components/core/header';
import CoreFooter from '@/components/core/footer';

const AdminDashboard = {
    name: 'admin',
    props: [],
    data: function() {
        return {
            project: null
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'users'
        ]),
        sortedUsers() {
            return this.users.sort((a, b) => {
                if (a.username < b.username) {
                    return -1;
                }
                if (a.username > b.username) {
                    return 1;
                }
                // a must be equal to b
                return 0;
            });
        }
    },
    methods: {
        isAdmin(user) {
            if (user.admin) {
                return user.admin;
            }
            return false;
        },
        toggleLeftSidenav() {
            NavBus.$emit('main-nav.open');
        },
        updateUser(user) {
            this.$store.dispatch('updateUser', {
                uid: user.uid,
                update: {
                    active_pay: user.active_pay,
                    stripe_id: user.stripe_id || null
                }
            });
        }
    },
    components: {
        'core-nav-main': CoreNavMain,
        'core-header': CoreHeader,
        'core-footer': CoreFooter
    },
    beforeRouteEnter: function(to, from, next) {
        next((vm) => {
            vm.$store.dispatch('setUsersRef', {
                ref: firebase.database().ref('users'),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: firebase.database().ref(`users/${firebase.auth().currentUser.uid}`),
                options: { readyCallback: () => {} }
            });
        });
    }
};

export default AdminDashboard;
</script>

<style>
.user-list {
    min-height: calc(100% - 64px);
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding-left: 16px;
    margin-bottom: 30px;
}

.user-list .header .md-layout{
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(0, 0, 0, .54);
}

.user-list {
    margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// admin-dashboard.vue?17496f25